var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69,57.2c-32.6,0-59,26.4-59,59S69,246,69,246s59-97.2,59-129.8S101.6,57.2,69,57.2z M69,142.8 c-16.3,0-29.5-13.2-29.5-29.5S52.7,83.8,69,83.8S98.5,97,98.5,113.3C98.5,129.5,85.3,142.8,69,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.5,157c15,38-49.9,46.4-49.9,46.4L86.3,246c0.2-0.2,52.5-3.1,71.2-14.8c18.7-11.6,28.9-31.5,29.5-44.7 c1-23.4-15.5-20.7-15.5-43.8c0-19.3,30.2-14.8,30.2-14.8S142.8,113.3,157.5,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.1,10c-20.4,0-36.9,16.5-36.9,36.9s36.9,81.1,36.9,81.1S246,67.2,246,46.9C246,26.5,229.5,10,209.1,10z  M209.1,61.6c-8.1,0-14.8-6.6-14.8-14.8S200.9,32,209.1,32s14.8,6.6,14.8,14.8C223.9,55,217.3,61.6,209.1,61.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.152b6c141df4407daa0981334d1ed507.svg";
export { ForwardRef as ReactComponent };